import { render, staticRenderFns } from "./filter_channel.vue?vue&type=template&id=79f28ba8&scoped=true"
import script from "./filter_channel.vue?vue&type=script&lang=js"
export * from "./filter_channel.vue?vue&type=script&lang=js"
import style0 from "./filter_channel.vue?vue&type=style&index=0&id=79f28ba8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f28ba8",
  null
  
)

export default component.exports